import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=0e53fa68&scoped=true&"
import script from "./confirmation.vue?vue&type=script&lang=ts&"
export * from "./confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=0e53fa68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53fa68",
  null
  
)

export default component.exports